import React, {useEffect, useState} from "react"
import {useHistory, useParams, withRouter} from "react-router-dom";
import Tabs from "react-simply-tabs";
import {getRanking} from "../../../services/enrollments";
import {Container} from "react-bootstrap";
import {getMatches} from "../../../services/matches";
import ScaleLoader from "react-spinners/ScaleLoader";
import {useSwipeableHook} from "../../../utils";
import {useTranslation} from "react-i18next";

// React Components
import RankingTable from "../../../components/RankingTable";
import Header from "../../../components/Header";
import GameCard from "../../../components/GameCard";

// CSS Files
import "./styles.css";

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
    `;

const Details = (props) => {
   const [ranking, setRanking] = useState(null);
   const [matches, setMatches] = useState(null);
   const [loading, setLoading] = useState(true);
   const history = useHistory();
   const { handlers, activeTabIndex, setActiveTabIndex } = useSwipeableHook(2);
   const {t} = useTranslation();
   let {leagueEditionId, leagueId, leagueDivisionId} = useParams();

   useEffect(() => {
      (async () => {
         let [ranking, matches] = await Promise.all([
            getRanking(leagueEditionId, leagueId, history.location.state.leagueCategoryId, leagueDivisionId),
            await getMatches(leagueEditionId, leagueId, history.location.state.leagueCategoryId, leagueDivisionId),
         ]);

         setRanking(ranking.rankings);
         setMatches(matches);
         setLoading(false);
      })()
   }, []);

   return <div className={"Details"}>
      <Header class={"mb-0"} headerBarTitle={t("other_leagues_page.header")} showBackButton/>

      <ScaleLoader
         css={override}
         sizeUnit={"px"}
         size={30}
         color={'#AFFF55'}
         loading={loading}
      />

      {!loading &&
         <div className={"flex-grow-1"} {...handlers}>
            <Tabs
               activeTabIndex={activeTabIndex}
               onRequestChange={setActiveTabIndex}
               controlsWrapperProps={{
                  className: "tab-controls-container"
               }}
               activeControlProps={{
                  className: "tab-control-active"
               }}
               controls={[
                  <button type="button" className="btn-tab-control">{t("other_leagues_page.ranking")}</button>,
                  <button type="button" className="btn-tab-control">{t("other_leagues_page.matches")}</button>
               ]}
            >
               <Container className={"p-0"}>
                  <RankingTable ranking={ranking}/>
               </Container>

               <div className={"matches-container"}>
                  {matches.map(match => {
                     return <GameCard key={match.id} gameInfo={match}/>
                  })}
               </div>
            </Tabs>
         </div>
      }
   </div>
}

export default withRouter(Details);
